import { render, staticRenderFns } from "./CritereBase.vue?vue&type=template&id=1488d990"
import script from "./CritereBase.vue?vue&type=script&lang=js"
export * from "./CritereBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports